// Module
var code = "<div id=\"{{id}}\" class=\"{{class}}\"> <div class=\"saved-payment-list hide\"> <div class=\"list-title\" data-i18n=\"checkout_savedPaymentMethods\"></div> <div class=\"data\"></div> </div> <div class=\"other-payment-list\"> <div class=\"list-title\" data-i18n=\"checkout_otherPaymentMethods\"></div> <div class=\"data\"></div> </div> </div>";
// Exports
module.exports = code;